import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';


import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';
const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    marginRight: theme.spacing.unit,
  },
  section1: {
    margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  section2: {
    margin: theme.spacing.unit * 2,
  },
  section3: {
    margin: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
    maxWidth:'50px',
  },
});

class  SelectDelivearble extends React.Component  {
  state={}

  constructor(props)
  {
    super(props);
    //bindings
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
  }

  componentDidMount()
  {
    //Consultar los deliverables 
    this.props.actions.fetchDeliverables(this.props.ca, this.props.project)
    .then(res=>{
      if(res.data.deliverables && res.data.deliverables.length>0)
      {
        let deliverables = res.data.deliverables.map(deliverable=>{
          let w = {};
          w.deliverable = w.value =deliverable.deliverable;
          w.name = w.label= deliverable.name;
          return w;
        });
        let all= {};
        all.deliverable = all.value= -1;//significa todos!
        all.name=all.label = "All";
        deliverables.unshift(all);
        this.setState({
          deliverables: deliverables, 
          deliverable: -1, 
        });
        this.props.changeDeliverable(-1);
      }
    });
  }

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeSelection(val)
  {
    this.setState({deliverable:val});
    this.props.changeDeliverable(val.deliverable);
  }

  render()
  {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <div className={classes.section1}>
          <Grid container spacing={24}>
          {!(this.props.project > 0)?
            <Grid item sm={3}>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Control Account</InputLabel>
               <Typography gutterBottom variant="h5">
                {this.props.ca_name}
              </Typography>
            </Grid>:null
            }
            <Grid item sm={3}>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Deliverable</InputLabel>
                <Select
                  menuContainerStyle={{'zIndex': 999}}
                  required
                  id="deliverable"
                  name="deliverable"
                  value={this.getValueCatalog(this.state.deliverables,this.state.deliverable)}
                  onChange={this.handleChangeSelection}
                  options={this.state.deliverables}
                >
                </Select>
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  }
}

SelectDelivearble.propTypes = {
  classes: PropTypes.object.isRequired,
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    summary: state.summary,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectDelivearble));



// WEBPACK FOOTER //
// ./src/features/summary/SelectDeliverable.js